import api from './api';

export const authService = {
  login: (credentials) => api.post('/auth/login', credentials).then(res => res.data),
  getMe: () => api.get('/auth/me').then(res => res.data),
};